import { Ref, forwardRef, useImperativeHandle, useMemo, useState } from "react"
import { FormatTableDataProps, FormatTableDataRef } from "./types"

const FormatTableData = forwardRef((props: FormatTableDataProps, ref: Ref<FormatTableDataRef>) => {
    const [checks, setChecks] = useState<(number | string)[]>([])
    const rowsWithError = useMemo(() => props.data.data?.filter((item) => !!item.Errores)?.map((item) => item.id ?? ''), [props.data.data])
    const selectCombination = (e: any) => {
        setChecks(e.checks?.filter((item: string) => !rowsWithError.includes(item)))
    }

    useImperativeHandle(ref, () => ({
        removeselectedData: () => {
            setChecks([])
        }
    }))

    const confirmMassiveLoad = () => {
        const dataFilter = props.data.data?.filter(item => !!item.id && checks?.includes(item.id))
        props.confirm({ data: dataFilter, checks })
    }

    return props.children({
        column: props.column, row: props.data.data, rowsWithError, loading: props.loading, cancelBulkLoad: props.cancelBulkLoad, text: {
            ...props.text,
            error: {
                ...props.text.error,
                amount: rowsWithError?.length.toString()
            },
            success: {
                ...props.text.success,
                amount: (props.data.data?.length).toString()
            },
        }, selectCombination, confirmMassiveLoad, checks
    })
})

export { FormatTableData }